import { render, staticRenderFns } from "./commonHeader2.vue?vue&type=template&id=5c9164fa&scoped=true&"
import script from "./commonHeader2.vue?vue&type=script&lang=js&"
export * from "./commonHeader2.vue?vue&type=script&lang=js&"
import style0 from "./commonHeader2.vue?vue&type=style&index=0&id=5c9164fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9164fa",
  null
  
)

export default component.exports